module.exports = __webpack_public_path__ + "img/16.5e1e096e.jpg";